import React, { useState, useMemo } from 'react';
import Select from 'react-select';
import { departamentos } from '../../data/colombia';
import './SelectCiudad.css';

const SelectCiudad = ({ value, onChange, onCiudadChange }) => {
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(null);
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState(null);

  // Opciones de departamentos para react-select
  const departamentoOptions = useMemo(() => {
    return departamentos.map(dep => ({
      value: dep.id,
      label: dep.nombre
    }));
  }, []);

  // Opciones de municipios basadas en el departamento seleccionado
  const municipioOptions = useMemo(() => {
    if (!departamentoSeleccionado) return [];
    const dep = departamentos.find(d => d.id === departamentoSeleccionado.value);
    if (!dep) return [];
    return dep.municipios.map(mun => ({
      value: mun,
      label: mun
    }));
  }, [departamentoSeleccionado]);

  const handleDepartamentoChange = (selected) => {
    setDepartamentoSeleccionado(selected);
    setCiudadSeleccionada(null);
    if (onCiudadChange) {
      onCiudadChange({ target: { name: 'ciudad', value: '' } });
    }
  };

  const handleCiudadChange = (selected) => {
    setCiudadSeleccionada(selected);
    if (onCiudadChange) {
      onCiudadChange({ target: { name: 'ciudad', value: selected ? selected.value : '' } });
    }
  };

  // Estilos personalizados para react-select
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: '2px 0',
      borderColor: '#ddd',
      borderRadius: '6px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#b8860b'
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f5f0e6' : 'white',
      color: '#333',
      cursor: 'pointer'
    })
  };

  return (
    <div className="select-ciudad">
      <div className="form-field">
        <label>Departamento</label>
        <Select
          options={departamentoOptions}
          value={departamentoSeleccionado}
          onChange={handleDepartamentoChange}
          placeholder="Buscar departamento..."
          isClearable
          styles={customStyles}
          noOptionsMessage={() => "No se encontraron departamentos"}
        />
      </div>

      {departamentoSeleccionado && (
        <div className="form-field">
          <label>Municipio / Ciudad</label>
          <Select
            options={municipioOptions}
            value={ciudadSeleccionada}
            onChange={handleCiudadChange}
            placeholder="Buscar municipio..."
            isClearable
            styles={customStyles}
            noOptionsMessage={() => "No se encontraron municipios"}
          />
        </div>
      )}
    </div>
  );
};

export default SelectCiudad;